import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from './Locales/i18n';
import { connect } from 'react-redux';
import { changeLanguageAction } from './actions/languageActionTypes';
import {
  SearchText,
  UATConstants,
  languages,
  updateUATConstants,
} from './Common/Models/UATConstants';
import translationENUS from 'src/Locales/en-US.json';
import translationENUK from 'src/Locales/en-UK.json';
import translationJA from 'src/Locales/ja.json';
import UATUSLogo from 'src/navbar/images/LocalizationIcons/icon _United States.png';
import UATUKLogo from 'src/navbar/images/LocalizationIcons/icon _United Kingdom.png';
import UATJapanLogo from 'src/navbar/images/LocalizationIcons/icon_Japan.png';
import UATtickmark from 'src/navbar/images/LocalizationIcons/String-icon-checkMark.png';
import { setLanguage } from './actions/Language';
import { ViewActions } from './dashboard/ViewActions';
import { UserContext } from './Models/UserProfile';
import { getUsers } from './actions/Actions';
import { getUserProfile } from './reducers/userProfileReducer';
import './index.css';
import { Dropdown, Option, FluentProvider, webLightTheme, type DropdownProps } from '@fluentui/react-components';
import { Language } from './Models/Language';
import { GetLanguageOptions } from './Common/Models/DropdownConstants';
import { DropdownService } from './Services/DropdownService';
import { t } from 'i18next';

export interface LanguageProps {
  i18n: any;
  t: any;
  language: string;
  changeLanguageAction: any;
  setLanguage: any;
  getUserProfile: any;
  userProfile: UserContext;
  userDetails?: UserContext;
}
export interface LanguageState {
  isPanelOpen: boolean;
  selectedOption: any;
  languageOptions: { key: string; text: string; icon?: string }[];
  newUrl: string;
}
class LanguageDropdown extends React.Component<LanguageProps, LanguageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isPanelOpen: false,
      selectedOption: '',
      languageOptions: [],
      newUrl: '',
    };
  }
  onLanguageChange = (languageCode: any) => {
    ViewActions.SetLanguage(languageCode, () => {
      this.props.setLanguage(languageCode);
    });
    this.props.changeLanguageAction(languageCode);
  };
  private getLoggedInUserProfile = () => {
    const user = this.props.userDetails;
    if (user) {
      this.setState(
        {
          selectedOption:
            user?.userSettings != undefined && user?.userSettings.LanguageCode != null
              ? user?.userSettings.LanguageCode
              : i18n.language,
        },
        () => {
          this.applyi18n();
        }
      );
      return;
    }
  };

  handleImageClick = (option: any) => {
    this.setState({
      isPanelOpen: !this.state.isPanelOpen,
      selectedOption: option,
    });
    const { i18n } = this.props;
    i18n.changeLanguage(option);
    this.onLanguageChange(option);
  };
  componentDidMount() {
    this.getLoggedInUserProfile();
  }
  updateSideMenu = () => {
    const { t, i18n } = this.props;
    if (
      window.location.pathname !== UATConstants.Routes.LandingPage &&
      window.location.pathname !== UATConstants.Routes.Dashboard
    ) {
      const queryParams = new URLSearchParams(window.location.search);
      const tabValue = queryParams.get('tab') as string;
      const translatedValue = t(tabValue);
      this.updateURLParameter('tab', translatedValue);
    }
  };

  updateURLParameter = (key: any, value: any) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key, value);
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({}, '', newUrl);
    this.setState({
      newUrl: window.location.pathname + '?' + urlParams.toString(),
    });
  };
  componentDidUpdate(prevProps: any, prevState: any) {
    const { i18n } = this.props;
    if (prevProps.userDetails !== this.props.userDetails) {
      this.setState({
        selectedOption: i18n.language,
      });
    }
  }
  applyi18n() {
    const searchContants = {
      SearchTextInprogress: SearchText.InProgress,
      SearchTextNoActions: SearchText.NoActions,
    };
    const constantObjects = [
      UATConstants.PlaceholdersAndTitles,
      UATConstants.RatingContext,
      UATConstants.ErrorMessages,
      UATConstants,
      searchContants,
    ];
    let translationFile: any;
    switch (this.state.selectedOption) {
      case 'ja':
        translationFile = translationJA;
        break;
      case 'en-UK':
        translationFile = translationENUK;
        break;
      default:
        translationFile = translationENUS;
        break;
    }

    constantObjects.forEach((constant) => {
      for (const propertyName of Object.keys(constant)) {
        if (i18n.exists(propertyName)) {
          constant[propertyName] = i18n.t(propertyName);
        }
      }
    });
  }
  getLanguageOptions = () => {
    return languages.map((language: any) => {
      return {
        key: language.code,
        text: language.name,
        icon: language.flag,
      };
    });
  };

  render() {
    const dropdownOptions = this.getLanguageOptions();
    const iconStyles: React.CSSProperties = { marginRight: '8px', width: '20px', height: '14px', verticalAlign: 'middle' };

    const handleOptionSelect: DropdownProps['onOptionSelect'] = (_event, data) => {
      if (data.optionValue) {
        this.handleImageClick(data.optionValue);
      }
    };

    const selectedOption = dropdownOptions.find((opt) => opt.key === this.state.selectedOption);
    const selectedDisplayValue = selectedOption ? selectedOption.text : '';
    const hasSelectedIcon = Boolean(selectedOption?.icon);

    return (
      <FluentProvider theme={webLightTheme}>
        {dropdownOptions.length > 0 && (
          <div style={{ marginTop: '10px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, marginBottom: '8px' }}>Change Language</label>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
              {hasSelectedIcon && (
                <img
                  src={selectedOption!.icon}
                  alt={`${selectedOption!.text} Flag`}
                  style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '20px',
                    height: '14px',
                    zIndex: 1,
                    pointerEvents: 'none',
                  }}
                />
              )}
              <Dropdown
                placeholder='Select a Language'
                aria-label='Choose your Language'
                appearance='outline'
                style={{ width: '100%' }}
                selectedOptions={this.state.selectedOption ? [this.state.selectedOption] : []}
                value={selectedDisplayValue}
                onOptionSelect={handleOptionSelect}
                button={hasSelectedIcon ? { style: { paddingLeft: '36px' } } : undefined}
              >
                {dropdownOptions.map((option) => (
                  <Option key={option.key} value={option.key} text={option.text}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {option.icon && (
                        <img src={option.icon} alt={`${option.text} Flag`} style={iconStyles} />
                      )}
                      <span>{option.text}</span>
                    </div>
                  </Option>
                ))}
              </Dropdown>
            </div>
          </div>
        )}
      </FluentProvider>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    language: state.languageReducer.language,
  };
};

const mapDispatchToProps = {
  changeLanguageAction: changeLanguageAction,
  setLanguage: setLanguage,
  setUsers: getUsers,
  getUserProfile: getUserProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LanguageDropdown));
// Generated by GitHub Copilot | Updated on: 2026-06-17 | 40 lines modified | Migrated Dropdown from @fluentui/react (v8) to @fluentui/react-components (v9)
// Generated by GitHub Copilot | Updated on: 2026-06-17 | 15 lines modified | Added FluentProvider wrapper and fixed flag icon display
// Generated by GitHub Copilot | Updated on: 2026-06-17 | 10 lines modified | Positioned flag icon inside dropdown trigger using CSS overlay
// Generated by GitHub Copilot | Updated on: 2026-06-22 | 5 lines modified | Added Change Language label above dropdown to match mock design
// Generated by GitHub Copilot | Updated on: 2026-06-22 | 3 lines modified | Aligned Change Language label and dropdown on same line with left-right spacing
